import { IShipmentCard } from "../../../../../models";
import ShipmentCardDashboardBase from "../shipment-card-dashboard-base/ShipmentCardDashboardBase";
import "./ShipmentCardDashboardOrigin.scss";

const ShipmentCardDashboardOrigin = ({ className, ...rest }: IShipmentCard) => (
    <ShipmentCardDashboardBase className={`ShipmentCardDashboardOrigin ${className || ""}`} {...rest} />
);

export default ShipmentCardDashboardOrigin;
